import { render, staticRenderFns } from "./t-app-menu-right.vue?vue&type=template&id=2136acf7&scoped=true&"
import script from "./t-app-menu-right.vue?vue&type=script&lang=js&"
export * from "./t-app-menu-right.vue?vue&type=script&lang=js&"
import style0 from "./t-app-menu-right.vue?vue&type=style&index=0&id=2136acf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136acf7",
  null
  
)

export default component.exports